import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  FlagsContainer,
  FlagButton
} from './LanguageFlags.styles';

const LanguageFlags = ({ variant = "default" }) => {
  const { language, changeLanguage } = useLanguage();
  const v = variant === "dark" ? "dark" : "default";

  return (
    <FlagsContainer>
      {/* Bandeira do Brasil */}
      <FlagButton
        type="button"
        onClick={() => changeLanguage("pt")}
        isActive={language === "pt"}
        $variant={v}
        aria-label="Mudar para Português"
        title="Português"
      >
        <svg
          viewBox="0 0 60 40"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Fundo verde */}
          <rect width="60" height="40" fill="#009739"/>
          {/* Losango amarelo */}
          <polygon
            points="30,5 55,20 30,35 5,20"
            fill="#FEDD00"
          />
          {/* Círculo azul */}
          <circle
            cx="30"
            cy="20"
            r="7"
            fill="#012169"
          />
          {/* Faixa branca */}
          <path
            d="M 23 20 Q 30 22, 37 20"
            stroke="white"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      </FlagButton>

      {/* Bandeira dos Estados Unidos */}
      <FlagButton
        type="button"
        onClick={() => changeLanguage("en")}
        isActive={language === "en"}
        $variant={v}
        aria-label="Change to English"
        title="English"
      >
        <svg
          viewBox="0 0 60 40"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Listras vermelhas */}
          <rect width="60" height="3.08" y="0" fill="#B22234"/>
          <rect width="60" height="3.08" y="6.15" fill="#B22234"/>
          <rect width="60" height="3.08" y="12.31" fill="#B22234"/>
          <rect width="60" height="3.08" y="18.46" fill="#B22234"/>
          <rect width="60" height="3.08" y="24.62" fill="#B22234"/>
          <rect width="60" height="3.08" y="30.77" fill="#B22234"/>
          <rect width="60" height="3.08" y="36.92" fill="#B22234"/>
          
          {/* Listras brancas */}
          <rect width="60" height="3.08" y="3.08" fill="white"/>
          <rect width="60" height="3.08" y="9.23" fill="white"/>
          <rect width="60" height="3.08" y="15.38" fill="white"/>
          <rect width="60" height="3.08" y="21.54" fill="white"/>
          <rect width="60" height="3.08" y="27.69" fill="white"/>
          <rect width="60" height="3.08" y="33.85" fill="white"/>
          
          {/* Retângulo azul */}
          <rect width="24" height="17.14" fill="#3C3B6E"/>
          
          {/* Estrelas (simplificadas) */}
          <circle cx="3" cy="2" r="0.8" fill="white"/>
          <circle cx="6" cy="2" r="0.8" fill="white"/>
          <circle cx="9" cy="2" r="0.8" fill="white"/>
          <circle cx="12" cy="2" r="0.8" fill="white"/>
          <circle cx="15" cy="2" r="0.8" fill="white"/>
          <circle cx="18" cy="2" r="0.8" fill="white"/>
          <circle cx="21" cy="2" r="0.8" fill="white"/>
          
          <circle cx="4.5" cy="4" r="0.8" fill="white"/>
          <circle cx="7.5" cy="4" r="0.8" fill="white"/>
          <circle cx="10.5" cy="4" r="0.8" fill="white"/>
          <circle cx="13.5" cy="4" r="0.8" fill="white"/>
          <circle cx="16.5" cy="4" r="0.8" fill="white"/>
          <circle cx="19.5" cy="4" r="0.8" fill="white"/>
          
          <circle cx="3" cy="6" r="0.8" fill="white"/>
          <circle cx="6" cy="6" r="0.8" fill="white"/>
          <circle cx="9" cy="6" r="0.8" fill="white"/>
          <circle cx="12" cy="6" r="0.8" fill="white"/>
          <circle cx="15" cy="6" r="0.8" fill="white"/>
          <circle cx="18" cy="6" r="0.8" fill="white"/>
          <circle cx="21" cy="6" r="0.8" fill="white"/>
          
          <circle cx="4.5" cy="8" r="0.8" fill="white"/>
          <circle cx="7.5" cy="8" r="0.8" fill="white"/>
          <circle cx="10.5" cy="8" r="0.8" fill="white"/>
          <circle cx="13.5" cy="8" r="0.8" fill="white"/>
          <circle cx="16.5" cy="8" r="0.8" fill="white"/>
          <circle cx="19.5" cy="8" r="0.8" fill="white"/>
          
          <circle cx="3" cy="10" r="0.8" fill="white"/>
          <circle cx="6" cy="10" r="0.8" fill="white"/>
          <circle cx="9" cy="10" r="0.8" fill="white"/>
          <circle cx="12" cy="10" r="0.8" fill="white"/>
          <circle cx="15" cy="10" r="0.8" fill="white"/>
          <circle cx="18" cy="10" r="0.8" fill="white"/>
          <circle cx="21" cy="10" r="0.8" fill="white"/>
          
          <circle cx="4.5" cy="12" r="0.8" fill="white"/>
          <circle cx="7.5" cy="12" r="0.8" fill="white"/>
          <circle cx="10.5" cy="12" r="0.8" fill="white"/>
          <circle cx="13.5" cy="12" r="0.8" fill="white"/>
          <circle cx="16.5" cy="12" r="0.8" fill="white"/>
          <circle cx="19.5" cy="12" r="0.8" fill="white"/>
          
          <circle cx="3" cy="14" r="0.8" fill="white"/>
          <circle cx="6" cy="14" r="0.8" fill="white"/>
          <circle cx="9" cy="14" r="0.8" fill="white"/>
          <circle cx="12" cy="14" r="0.8" fill="white"/>
          <circle cx="15" cy="14" r="0.8" fill="white"/>
          <circle cx="18" cy="14" r="0.8" fill="white"/>
          <circle cx="21" cy="14" r="0.8" fill="white"/>
        </svg>
      </FlagButton>
    </FlagsContainer>
  );
};

export default LanguageFlags;

